import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

import {Box, createMuiTheme, createTheme, ThemeProvider} from "@mui/material";
import ApiVoteCtrl from "./svc/vote/ApiVoteCtrl";
import AppDatavote from "./AppDatavote";

import '@fontsource/inter';

import * as turf from "@turf/turf";
import Map, {Layer, Marker, Popup, Source} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// eslint-disable-next-line
import mapboxgl from '!mapbox-gl';
import * as KendoLicensing from "@progress/kendo-licensing";
import AppDatavoteMenu from "./AppDatavoteMenu";
import AppDatavoteHeader from "./AppDatavoteHeader";


// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;

KendoLicensing.setScriptKey("141j044b041h541j4i1d542e581e4i1i4g260i2k0f2e0026082h0f2f012b14611959014g2f4g3951482f0b2j0f51482g121i375d3154454d034h39580i5e364k0e2f492f44544126092k444d34563e2151064g072k0a3e1d551g0j472019592g0a4h04572d57470838094h114a2c5e1a424g0h370c4i1b3h015d3c5036192i451b51024c1i35234e0b320i382j5b360b4e21440h6123135i2e58380e4e26482k5g25422d4c0j5b1b4j0b4d2h53451e5g204k243b1i3c1b5h2313591j5i27081h342g57155f3b135b2j432e3i02284g215g2i053k004217460b4a0g360c4h0i5i1a432h3d11360c2g5a184b293h2k5j0g5b2i51024c1e51143h2j524b2i5i12552d562j3e25181k310f4h1b0j481345541b460b2f5d284f0g452d4d1632143k1434003a612c4806511i3e0k542d4f2f40133d0e4i21562c330c391b3a0j5h3b611h0k322e5b1e5h3a0j4006551b5b175730520f4e23602d350d4c134k2703411b34581i542d5b2j0b331j35244f2a4h3i193a0g4j21612g33135c1b4015490g1d53300e4i304100275k1k3f5k293a0b4j1k35015f1c3d05592i561g17285732214i3c1a480a49572f511e500355045a145j3f115j1e572j430e511a5j193509521f094f093f1a3b1a445508380a2f5421312458151k49523k26450j3i4j2k49542k5j253d184g1k46204g022h4b2j44185j29580b3g2c55082h414h111d4i3j510147213b191h3a224e0a31571e421b461949214c254f003g5g2b5h2a4f2c4j41265j0e4b0d470327054j3b2h4600320d2j041k5f2d4e054e0d3c0k481541235k254515470k591f3a61135a214g0946135h431a3e0552095i12561860285d1h3c2958064e1h4j123j0h1d4i284f00592e09375d2h591h4030492g311c114b2c4i3j111b581j442b3d2k42255i224f1i0j5k152053465e3804512661135a3409451e46082k3h1d5f2g42125f411b3d192949154a2317395i0b284k1i3d074b5146544b512b0555084h49280a3d5k3f012f3i4g085f0c4k303a1c4g2k3f5g2c5g10453045560e2g4002521i4a09370g5i201359102d512d");

export function Pin({pinStyle, size}) {

    return (
        <svg height={size} viewBox="0 0 24 24" style={pinStyle}>
            <path d={ICON}/>
        </svg>
    );
}

export default function App() {


    const queryParameters = new URLSearchParams(window.location.search)
    const header = queryParameters.get("header");

    const listOfIrisRaw = queryParameters.get("listOfIris") ? queryParameters.get("listOfIris") : "480950101,480950102,480950105";
    const codeInsee = queryParameters.get("codeInsee") ? queryParameters.get("codeInsee") : "48095";
    const electionType = queryParameters.get("election") ? queryParameters.get("election") : "muni";


    const theme = createTheme({
        typography: {
            fontFamily: [
                'Inter',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
        breakpoints: {
            values: {
                md: 1200,
                lg: 1440,
                xl: 1745,
            },
        }
    });

    if (header === null) {
        return (<ThemeProvider theme={theme} sx={{
            width: "100dvw",
            height: "100dvh",
            overflow: "hidden",
        }}>
            <AppDatavoteMenu codeInsee={codeInsee} electionType={electionType}/>
        </ThemeProvider>)
    } else if (header==="") {
        return (<ThemeProvider theme={theme} sx={{
            width: "100dvw",
            height: "100dvh",
            overflow: "hidden",
        }}>
            <AppDatavoteHeader codeInsee={codeInsee} electionType={electionType}/>
        </ThemeProvider>)
    }
}
